/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit InfoBadgeInline.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import Info from 'DesignSystem/Info/view.js'
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  justifyContent: "center",
  width: 'var(--width)',
minWidth: 'var(--minWidth)',
maxWidth: 'var(--maxWidth)',
height: 'var(--height)',
marginLeft: 'var(--marginLeft)'})
styles.Vertical1 = css({label: 'Vertical1',
  backdropFilter: "blur(10px)",
height: 16,
paddingLeft: 8,
paddingRight: 8,
justifyContent: "center",
alignItems: "center",
borderBottomLeftRadius: 4,
borderBottomRightRadius: 4,
borderTopLeftRadius: 4,
borderTopRightRadius: 4,
transform: "translateX(0)",
borderWidth: 1,
borderStyle: "solid",
  backgroundColor: 'var(--backgroundColor)',
left: 'var(--left)',
borderColor: 'var(--borderColor)'})

export default function InfoBadgeInline({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  width= "auto",
minWidth= "auto",
maxWidth= "25%",
height= 50,
marginLeft= 16,
backgroundColor= "rgba(255,127,0,0.1)",
left= "auto",
borderColor= "rgba(255,127,0,1)",
text,
color= "rgba(255,127,0,1)"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="InfoBadgeInline.Vertical"
 data-view-path={dataViewPath}
 style={{'--width': typeof width === 'number' ? `${width}px` : width,'--minWidth': typeof minWidth === 'number' ? `${minWidth}px` : minWidth,'--maxWidth': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--height': typeof height === 'number' ? `${height}px` : height,'--marginLeft': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft}}
 className={`views-block ${styles.Vertical}`}
>
<div
 data-testid="InfoBadgeInline.Vertical:1"
 data-view-path={dataViewPath}
 style={{'--backgroundColor': backgroundColor,'--left': typeof left === 'number' ? `${left}px` : left,'--borderColor': borderColor}}
 className={`views-block ${styles.Vertical1}`}
>
<Info
 data-testid="InfoBadgeInline.Info"
 data-view-path={dataViewPath}
 text={text}
 fontSize={9}
 color={color}
 marginTop={1}
 fontWeight={200}
/>
</div>
</div>
{children}
</React.Fragment>)
}